export default __webpack_public_path__ + "static/media/mu-header-img.824b9c3a.svg";